import JoinForm from './joinForm';

export default JoinForm;
